module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as290-91b7b6e80786658cc0544d0bddbf9564.jpg";